import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const BrandCodeContext = createContext<string | undefined>(undefined)

/** Provides the active brand code for config RPCs. Wire from the UI BrandProvider. */
export function BrandCodeProvider({
  brandCode,
  children,
}: PropsWithChildren<{ brandCode?: string }>) {
  return (
    <BrandCodeContext.Provider value={brandCode}>
      {children}
    </BrandCodeContext.Provider>
  )
}

export function useBrandCode() {
  return useContext(BrandCodeContext)
}
